export const PartCategories = [
  { id: 5, text: "Windscreens" },
  { id: 3, text: "Side Mirrors" },
  { id: 2, text: "Brake Pads" },
  { id: 1, text: "Grill & Bumper" },
  { id: 4, text: "Headlights" },
  { id: 8, text: "Bonnets" },
  { id: 9, text: "Doors" },
];
